import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton } from '@ionic/react';

type CardAddValueButtonProps = {
  isValid: boolean;
  proceed: () => void;
};

export default function CardAddValueButton({
  isValid,
  proceed,
}: CardAddValueButtonProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <div className="pt-3 ion-text-center">
        <IonButton
          className={
            'btn-default btn-wide-80 ' + (isValid ? '' : 'btn-disabled')
          }
          onClick={() => proceed()}
        >
          {t('cardvalue.load')}
        </IonButton>
      </div>
    </>
  );
}
